import React from "react";
import { Tooltip } from "antd";
import { useHistory, useLocation } from "react-router-dom";
import ActionHubIcon from "../../components/NewDashboard/DashboardIcons/ActionHubIcon";
import canViewActionHub from "../../util/actionHubAccess";
import "./ActionHubButton.css";

const HUB_SUFFIX = "/pending-task-list";
const TITLE = "Action Hub";

const ActionHubButtonInner = () => {
  const history = useHistory();
  const location = useLocation();
  const companySlug = localStorage.getItem("companyDomain");
  const hubPath = `/${companySlug}${HUB_SUFFIX}`;
  const isActive = location.pathname.endsWith(HUB_SUFFIX);

  return (
    <li className="gx-language">
    <Tooltip title={TITLE}>
      <button
        type="button"
        className={`action-hub-btn${isActive ? " action-hub-btn--active" : ""}`}
        aria-label={TITLE}
        aria-current={isActive ? "page" : undefined}
        onClick={() => history.push(hubPath)}
      >
        <span className="action-hub-btn__icon">
          <ActionHubIcon width={18} height={18} color="#ffffff" />
        </span>
        <span className="action-hub-btn__divider" />
        <span className="action-hub-btn__label">Action Hub</span>
      </button>
    </Tooltip>
    </li>
  );
};

/** Header entry to the Action Hub with the total pending count. Renders (and fetches) nothing without access. */
const ActionHubButton = () => (canViewActionHub() ? <ActionHubButtonInner /> : null);

export default ActionHubButton;
